import { FormSelectSchool } from './FormSelectSchool';

export { FormSelectSchool };
export default FormSelectSchool;
